import { Switch } from "@/ui/components/Switch";

/**
 * Switch + title + helper text in a bordered row. Used heavily by the
 * Phase 1 toggles ("Mark up vendor invoices", "Owner routing", etc.).
 */
interface ToggleRowProps {
  title: string;
  help?: string;
  checked: boolean;
  onCheckedChange: (v: boolean) => void;
  id?: string;
}

export function ToggleRow({ title, help, checked, onCheckedChange, id }: ToggleRowProps) {
  return (
    <label
      htmlFor={id}
      className="flex cursor-pointer items-start justify-between gap-4 rounded-lg border border-border bg-card px-4 py-3 transition-colors hover:border-slate-500"
    >
      <div className="flex flex-col gap-1">
        <span className="font-medium text-foreground">{title}</span>
        {help && <span className="text-sm text-muted-foreground">{help}</span>}
      </div>
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} className="mt-1 shrink-0" />
    </label>
  );
}
